(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["accio-slideshow-hero"] && !Shopify.designMode) return;
  try {
    
(function() {
  var section = document.getElementById('accio-slideshow-hero-{{ section.id }}');
  if (!section) return;

  var slides = section.querySelectorAll('.accio-slideshow-hero__slide');
  var dots = section.querySelectorAll('.accio-slideshow-hero__dot');
  var current = 0;
  var total = slides.length;
  var autoplayInterval = null;

  function goTo(index) {
    slides[current].classList.remove('accio-slideshow-hero__slide--active');
    dots[current] && dots[current].classList.remove('accio-slideshow-hero__dot--active');
    current = (index + total) % total;
    slides[current].classList.add('accio-slideshow-hero__slide--active');
    dots[current] && dots[current].classList.add('accio-slideshow-hero__dot--active');
  }

  function startAutoplay() {
    autoplayInterval = setInterval(function() { goTo(current + 1); }, 4000);
  }

  function stopAutoplay() {
    clearInterval(autoplayInterval);
  }

  dots.forEach(function(dot) {
    dot.addEventListener('click', function() {
      stopAutoplay();
      goTo(parseInt(dot.getAttribute('data-slide-target'), 10));
      startAutoplay();
    });
  });

  section.querySelectorAll('.accio-slideshow-hero__nav').forEach(function(btn) {
    btn.addEventListener('click', function() {
      stopAutoplay();
      var dir = btn.getAttribute('data-direction') === 'next' ? 1 : -1;
      goTo(current + dir);
      startAutoplay();
    });
  });

  if (total > 1) startAutoplay();
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
